const EXCEL_BOT_TOKEN = '91e55970-2833-4bd2-9cf3-f2f3c4bee238';

export { EXCEL_BOT_TOKEN};
